import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import "./NavbarStyles.css";
import ResumePdf from "../assets/Rajesh_Kumar_Resume.pdf"


import {FaBars,FaTimes} from "react-icons/fa";


export const Navbar = () => {

const [click,setClick]= useState(false);
const [color,setColor]=useState(false);

const changeColor = ()=>{
    if(window.scrollY>=100){
        setColor(true);
    }
    else{
        setColor(false)
    }
}

window.addEventListener("scroll",changeColor);

const handleClick=()=>{
    setClick(!click);
}
const handleResume =()=>{
   // navigate("https://drive.google.com/drive/folders/1OnPe54aMrfQ6ROiZoExaEh8qO0jYFgwD")
window.open("https://drive.google.com/file/d/1p1GS_5QXYUy_7k0-lH4us6py82_iZrZ9/view?usp=share_link","_blank")

}
//
//"https://drive.google.com/drive/folders/1OnPe54aMrfQ6ROiZoExaEh8qO0jYFgwD"
  return (
    <div className={color?"header header-bg":"header"}>
        <div className='resumePart'>
            <Link to="/">
                <h1>Rajesh Kumar</h1>
            </Link>
           
            <a href={ResumePdf} rel="noopener noreferrer" download   target="_blank" >
                <button onClick={handleResume} className='btn btn-light'style={{borderRadius:"20px"}}>Resume</button>
            </a>
            
        </div>
        <ul className={click?"nav-menu active":"nav-menu"}>
            <li>
                <Link to="/">Home</Link>
            </li>
            <li>
                <Link to="/about">About Me</Link>
            </li>
            <li>
                <Link to="/skill">Skills</Link>
            </li>
            <li>
                <Link to="/project">Project</Link>
            </li>
            <li>
                <Link to="/contact">Contact</Link>
            </li>
        </ul>
        <div className='hamburger' onClick={handleClick}>
            { click?<FaTimes size={20} style={{color:"#fff"}}/>:<FaBars size={20} style={{color:"#fff"}}/> }
        
        
        </div>
    </div>
  )
}
